import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap, map, catchError } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class FeatureFlagService {
  private flags = new Map<string, boolean>();
  private loaded = false;

  constructor(private http: HttpClient) {}

  load(): Observable<void> {
    return this.http.get<{ code: string; enabled: boolean }[]>(
      `${environment.formEngineEndpoint}feature-flags/public?portal=ext`
    ).pipe(
      tap(flags => {
        this.flags.clear();
        flags.forEach(f => this.flags.set(f.code, f.enabled));
        this.loaded = true;
      }),
      map(() => undefined),
      catchError(() => {
        console.warn('Feature flags unavailable, falling back to isProd logic');
        this.applyFallback();
        return of(undefined);
      }),
    );
  }

  isEnabled(code: string): boolean {
    if (!this.loaded) return this.fallbackValue();
    return this.flags.get(code) ?? false;
  }

  /** Fallback: mirrors old !isProd behavior when form-engine is unreachable */
  private applyFallback(): void {
    const enabled = !environment.isProd;
    this.flags.set('EXT_NOTIFICATIONS', enabled);
    this.flags.set('EXT_COMMUNICATION', enabled);
    this.flags.set('EXT_POST_REG_APPLICATION', enabled);
    this.flags.set('EXT_REPORTS', enabled);
    this.flags.set('EXT_REG_PROGRESS', enabled);
    this.flags.set('EXT_PAYMENTS', enabled);
    this.loaded = true;
  }

  private fallbackValue(): boolean {
    return !environment.isProd;
  }
}
